<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateRangeGround"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillrangeGroundForm="fillrangeGroundForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('samples.ranges')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillrangeGroundForm="fillrangeGroundForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.date') }}:</strong>
                        </h6>
                        {{ formatDate }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('samples.nutrient') }}:</strong>
                        </h6>
                        {{ rangeGroundForm.nutrient }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.crop') }}:</strong>
                        </h6>
                        {{ rangeGroundForm.crop }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.zone_supply') }}:</strong>
                        </h6>
                        {{ rangeGroundForm.zone }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.geographical_zone') }}:</strong
                          >
                        </h6>
                        {{ rangeGroundForm.subzone }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.variety') }}:</strong>
                        </h6>
                        {{ rangeGroundForm.crop_variety }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('samples.ranges') }}:</strong>
                        </h6>
                        <br />
                        <ul
                          v-for="(fert, index) in rangeGroundForm.names"
                          :key="index"
                        >
                          <li>
                            {{ $t('samples.range_name') }}:
                            {{ rangeGroundForm.names[index] }}
                          </li>
                          <li>
                            {{ $t('common_words.limit_lower') }}:
                            {{ rangeGroundForm.lim_inf_operators[index] }}
                            {{ rangeGroundForm.lim_infs[index] }}
                          </li>
                          <li>
                            {{ $t('common_words.limit_upper') }}:
                            {{ rangeGroundForm.lim_sup_operators[index] }}
                            {{ rangeGroundForm.lim_sups[index] }}
                          </li>
                          <li>
                            {{ $t('common_words.recommendation') }}:
                            {{ rangeGroundForm.recommendations[index] }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import moment from 'moment';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import { isset } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      rangeGroundForm: {},
      ground_nutrients: [],
    };
  },
  computed: {
    formatDate() {
      return moment(this.rangeGroundForm.date).format('YYYY-MM-DD');
    },
  },
  mixins: [mixinMasters, MixinPermissions, MixinMenu],
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ground_nutrient_id: null,
        crop_id: null,
        zone_id: null,
        subzone_id: null,
        crop_variety_id: [],
        date: null,
        businesses_id: [],
        id: null,
      };
      this.$refs.secondStep.cleanStep();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillrangeGroundForm(ref) {
      this.rangeGroundForm = Object.assign(
        {},
        this.rangeGroundForm,
        this.$refs[ref].model
      );

      if (ref == 'firstStep') {
        if (this.rangeGroundForm.ground_nutrient_id) {
          let indexToFind = this.$refs['firstStep'].ground_nutrients.findIndex(
            (n) => n.id == this.rangeGroundForm.ground_nutrient_id
          );
          this.rangeGroundForm.nutrient =
            this.$refs['firstStep'].ground_nutrients[indexToFind].description;
        }

        if (this.rangeGroundForm.crop_id) {
          let indexToFind = this.$refs['firstStep'].crops.findIndex(
            (n) => n.id == this.rangeGroundForm.crop_id
          );
          let crop = this.$refs['firstStep'].crops[indexToFind];
          this.rangeGroundForm.crop = isset(crop) ? crop.name : '';
        }

        if (this.rangeGroundForm.zone_id) {
          let indexToFind = this.$refs['firstStep'].zones.findIndex(
            (n) => n.id == this.rangeGroundForm.zone_id
          );
          this.rangeGroundForm.zone =
            this.$refs['firstStep'].zones[indexToFind].name;
        } else if (this.rangeGroundForm.zone_id == 0) {
          this.rangeGroundForm.zone = 'Ninguna';
        }

        if (this.rangeGroundForm.subzone_id) {
          let indexToFind = this.$refs['firstStep'].subzones.findIndex(
            (n) => n.id == this.rangeGroundForm.subzone_id
          );
          this.rangeGroundForm.subzone =
            this.$refs['firstStep'].subzones[indexToFind].name;
        } else if (this.rangeGroundForm.subzone_id == 0) {
          this.rangeGroundForm.subzone = 'Ninguna';
        }

        if (
          Array.isArray(this.rangeGroundForm.crop_variety_id) &&
          this.rangeGroundForm.crop_variety_id.length > 0
        ) {
          let varieties = this.$refs['firstStep'].crop_varieties.filter((n) =>
            this.rangeGroundForm.crop_variety_id.includes(n.id)
          );
          this.rangeGroundForm.crop_variety = varieties
            .map((v) => v.name)
            .join(', ');
        } else if (
          this.rangeGroundForm.crop_variety_id == 0 ||
          (Array.isArray(this.rangeGroundForm.crop_variety_id) &&
            this.rangeGroundForm.crop_variety_id.length === 0)
        ) {
          this.rangeGroundForm.crop_variety = 'Ninguna';
        }
      }
    },

    storeUpdateRangeGround() {
      this.showHideLoading(true);
      this.rangeGroundForm.route = 'grounds/ranges';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.rangeGroundForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.rangeGroundForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/grounds/ranges',
                'rangeGroundForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.rangeGroundForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/grounds/ranges',
                'rangeGroundForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  created() {
    Axios.getMasters('grounds/nutrients')
      .then((response) => {
        this.ground_nutrients = response.data.data;
      })
      .catch((error) => this.showMessageErrors(error));
  },

  mounted() {
    this.selectedItemOnMenu('grounds');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('grounds');
    sessionStorage.removeItem('editForm');
  },
};
</script>
